import React from 'react'
import { Field } from 'simple-react-form'
import styles from './styles.css'
import Int from 'App/components/fields/Int'

export default class Total extends React.Component {
  static propTypes = {}

  render() {
    return (
      <div className={styles.container}>
        <div className={styles.title}>
          <strong>Cálculos de la nota de venta</strong>
        </div>
        <div className="row">
          <div className="col-xs-12 col-sm-4">
            Sub total de productos
            <Field fieldName="subTotal" type={Int} />
          </div>
          <div className="col-xs-12 col-sm-4">
            Mes Anticipado
            <Field fieldName="mesAnticipado" type={Int} />
          </div>
          <div className="col-xs-12 col-sm-4">
            I.V.A Anticipado
            <Field fieldName="ivaAnticipado" type={Int} />
          </div>
          <div className="col-xs-12 col-sm-4">
            Total Mensualidad
            <Field fieldName="totalMensualidad" type={Int} />
          </div>
          <div className="col-xs-12 col-sm-4">
            Elementos Adicionales
            <Field fieldName="elementosAdicionales" type={Int} />
          </div>
          <div className="col-xs-12 col-sm-4">
            Valores Adicionales
            <Field fieldName="valorAdicionales" type={Int} />
          </div>
          <div className="col-xs-12 col-sm-4">
            Total Neto
            <Field fieldName="totalNeto" type={Int} />
          </div>
          <div className="col-xs-12 col-sm-4">
            I.V.A Anticipado
            <Field fieldName="ivaNeto" type={Int} />
          </div>
          <div className="col-xs-12 col-sm-4">
            Total
            <Field fieldName="total" type={Int} />
          </div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/App/Pages/Preparation/SSSellNoteAdvance/AdvanceForm/Total/index.js